import { useAtom } from 'jotai';
import { useLocation } from 'react-router-dom';
import { modalAtom } from 'store/modal';
import { TModal } from 'types/apis/modal';

type TProps = {
  isConfirm?: boolean;
  title?: string;
  text?: string;
  element?: JSX.Element;
  cancelBtnText?: string;
  submitBtnText?: string;
  onClickOutside?: () => void;
  onClickBtn?: () => void;
  onCancel?: () => void;
  onSubmit?: () => void;
};

const useModal = () => {
  const location = useLocation();
  const [modal, setModal] = useAtom(modalAtom);

  const closeModal = () => {
    setModal((prev: typeof modal) => {
      const newStack = prev.modalStack.slice(0, -1);
      return { ...prev, modalStack: newStack, isOpen: newStack.length > 0 };
    });
    document.body.style.overflowX = 'auto';
    document.body.style.overflowY = 'scroll';
    document.body.style.paddingRight = '';
  };

  const openModal = ({
    isConfirm,
    title,
    text,
    element,
    cancelBtnText,
    submitBtnText,
    onClickBtn,
    onClickOutside,
    onCancel,
    onSubmit,
  }: TProps) => {
    const newModal: TModal = {
      isOpen: true,
      isConfirm,
      title,
      text,
      cancelBtnText,
      submitBtnText,
      element,
      onClickOutside,
      onClickBtn,
      onCancel,
      onSubmit,
      location: location.pathname,
    };
    setModal((prev) => ({
      ...prev,
      modalStack: [...prev.modalStack, newModal],
    }));
  };

  return { modal, closeModal, openModal };
};

export default useModal;
